import { defineElement } from '~/utils';
import { formatGiftCardDate } from '~/utils/calendar-utils';

const attributes = {
  rightAwayCheckbox: 'data-delivery-date-checkbox-right-away',
  alternateDateCheckbox: 'data-delivery-date-checkbox-alternate',
};

class GiftDatePicker extends HTMLElement {
  constructor() {
    super();
    this.datePicker = this.querySelector('date-picker');
    this.sendOnInput = this.querySelector('input[name="properties[Send on]"]');

    this.rightAwayCheckbox = this.querySelector(`[${attributes.rightAwayCheckbox}]`);
    this.alternateDateCheckbox = this.querySelector(`[${attributes.alternateDateCheckbox}]`);
  }

  connectedCallback() {
    this.datePicker.addEventListener('date-picker::date-change', this.onDateChange.bind(this));
    this.rightAwayCheckbox.addEventListener('click', this.onRightAwayCheckboxClick.bind(this));
    this.alternateDateCheckbox.addEventListener('click', this.onAlternateDateCheckboxClick.bind(this));
    this.sendOnInput.value = formatGiftCardDate(new Date());
  }

  onRightAwayCheckboxClick() {
    this.sendOnInput.value = formatGiftCardDate(new Date());
  }

  onAlternateDateCheckboxClick() {
    const selectedAlternateDate = this.datePicker.value;

    if (!selectedAlternateDate) {
      this.sendOnInput.value = formatGiftCardDate(new Date());
    } else {
      this.setAlternateDate(selectedAlternateDate);
    }

    this.datePicker.open();
  }

  setAlternateDate(selectedDate) {
    this.sendOnInput.value = selectedDate;
  }

  onDateChange(event) {
    this.alternateDateCheckbox.checked = true;
    this.alternateDateCheckbox.dispatchEvent(new Event('change'));
    this.setAlternateDate(event.detail.date);
  }
}

defineElement('giftcard-date-picker', GiftDatePicker);